// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import './Deployment.scss'
import { ReactComponent as AICloudSolutionFrameworkMD } from '../../../../static/images/aicloud-solution-framework.svg'
import { ReactComponent as AICloudSolutionFrameworkXS } from '../../../../static/images/aicloud-solution-framework-xs.svg'
import { ReactComponent as AICloudSolutionFrameworkSM } from '../../../../static/images/aicloud-solution-framework-sm.svg'

const Deployment: React.FC = (): JSX.Element => {
  return (
    <div className="deployment-container px-s10 py-s11">
      <div className="internal-container gap-s9">
        <div className="deployment-title-container">
          <h2>
            <span className="display-4">AI Cloud has options for your different needs</span>
          </h2>
          <span className="lead">Experience the freedom of open source running on Intel hardware</span>
        </div>
        <div className="deployment-framework-container mx-auto d-none d-md-flex">
          <AICloudSolutionFrameworkMD />
        </div>
        <div className="deployment-framework-container mx-auto d-md-none d-sm-flex d-none">
          <AICloudSolutionFrameworkSM />
        </div>
        <div className="deployment-framework-container mx-auto d-sm-none d-flex">
          <AICloudSolutionFrameworkXS />
        </div>
      </div>
    </div>
  )
}

export default Deployment
